export default __webpack_public_path__ + "static/media/transaction-help.56af95a3.png";